import { replacePathParams } from '../http/replacePathParams';

import { type BoostedImpressionsAttributions } from './aliases';

import {
  BOOSTED_CLICK_ATTR_ENDPOINT,
  BOOSTED_IMPRESSIONS_ATTRIBUTION_ENDPOINT,
} from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';

export function updateBoostedImpressionsAttributions(
  impressions: BoostedImpressionsAttributions
) {
  return typedHttp.post(
    BOOSTED_IMPRESSIONS_ATTRIBUTION_ENDPOINT,
    {
      impressions,
    },
    {
      withAuth: true,
    }
  );
}

export function sendBoostedAttributionClick(productId: number) {
  return typedHttp.post(
    replacePathParams(BOOSTED_CLICK_ATTR_ENDPOINT, {
      productId: String(productId),
    }),
    null,
    {
      withAuth: true,
    }
  );
}
